import createVueComponent from '../createVueComponent';

const ParkingCircle = createVueComponent('ParkingCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M9 17V7h4a3 3 0 0 1 0 6H9', key: '1dfk2c' }],
]);

export default ParkingCircle;
